import script from "./Investment.vue?vue&type=script&setup=true&lang=js"
export * from "./Investment.vue?vue&type=script&setup=true&lang=js"

import "./Investment.vue?vue&type=style&index=0&id=53cd8ab4&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-53cd8ab4"]])

export default __exports__